module.exports = __webpack_public_path__ + "img/config.3c6fb8dc.svg";